import styles from './Flag.module.css'
import classNames from 'classnames'

const FLAG_SVGS_BASE_URL = 'https://huel.io/flags/' // INFO: Must have trailing slash

interface FlagProps {
  countryIsoCode: string
  isRounded?: boolean
}

//TODO: Move flags to be locally hosted
export const Flag = ({ countryIsoCode = 'uk', isRounded }: FlagProps) => {
  const url = new URL(`${countryIsoCode.toLowerCase()}.svg`, FLAG_SVGS_BASE_URL)

  const flagClasses = classNames(styles.Flag, {
    [styles['Flag--is-rounded']]: isRounded,
  })

  return <img className={flagClasses} alt={countryIsoCode} src={url.href} width={24} height={24} loading="lazy" />
}
